import { render } from "./BurreauEquipeResiliations.vue?vue&type=template&id=5ae0f396&scoped=true"
import script from "./BurreauEquipeResiliations.vue?vue&type=script&lang=js"
export * from "./BurreauEquipeResiliations.vue?vue&type=script&lang=js"

import "./BurreauEquipeResiliations.vue?vue&type=style&index=0&id=5ae0f396&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ae0f396"]])

export default __exports__